import { render, staticRenderFns } from "./CarouselTabsItems.vue?vue&type=template&id=2ebb6773&scoped=true"
import script from "./CarouselTabsItems.vue?vue&type=script&lang=js"
export * from "./CarouselTabsItems.vue?vue&type=script&lang=js"
import style0 from "./CarouselTabsItems.vue?vue&type=style&index=0&id=2ebb6773&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ebb6773",
  null
  
)

export default component.exports